import "./index.css";
import { Marquee } from "@/components/magicui/marquee";
import logo from "../assets/lbh-logo.png";
import bruceBee from "../assets/images/bruce-bee.png";
import cooking4Change from "../assets/images/cooking4change.png";
import deliciousDunedin from "../assets/images/delicious-dunedin.png";
import fishmob from "../assets/images/fishmob.png";
import frameMeBaby from "../assets/images/frame-me-baby.jpg";
import framingFactory from "../assets/images/framing-factory.jpg";
import fundraiserCookbook from "../assets/images/fundraisercookbook.png";

type Brand = { name: string; src: string };

const brands: Brand[] = [
  { name: "Bruce Bee", src: bruceBee },
  { name: "Cooking 4 Change", src: cooking4Change },
  { name: "Delicious Dunedin", src: deliciousDunedin },
  { name: "Fishmob", src: fishmob },
  { name: "Frame Me Baby", src: frameMeBaby },
  { name: "Framing Factory", src: framingFactory },
  { name: "Fundraiser Cookbook", src: fundraiserCookbook },
];

export function App() {
  return (
    <div className="min-h-[100svh] flex flex-col">
      <header className="px-5 sm:px-8 py-5 sm:py-8 flex items-end gap-3 sm:gap-4">
        <img
          src={logo}
          alt="Lunch Boys Media"
          className="h-[4.5rem] sm:h-20 w-auto"
        />
        <span className="flex flex-col leading-[0.95] font-semibold tracking-tight text-lg sm:text-xl">
          <span>Lunch</span>
          <span>Boys</span>
          <span>Media</span>
        </span>
      </header>

      <main className="flex-1 flex items-center px-5 sm:px-8 py-4">
        <div className="max-w-6xl">
          <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-semibold tracking-tight leading-[1.1] sm:leading-[1.05]">
            Investors in art, food content, and consumer brands.
          </h1>
          <p className="mt-6 sm:mt-10 text-base sm:text-lg text-muted-foreground">
            Get in touch{" "}
            <a
              href="mailto:hello@lunchboys.media"
              className="text-foreground font-medium underline-offset-4 hover:underline"
            >
              hello@lunchboys.media
            </a>
          </p>
        </div>
      </main>

      <footer className="border-t border-border/60 py-5 sm:py-10">
        <p className="px-5 sm:px-8 mb-3 sm:mb-6 text-xs sm:text-sm uppercase tracking-widest text-muted-foreground">
          Our brands
        </p>
        <Marquee className="[--gap:2.5rem] sm:[--gap:4rem] [--duration:35s] p-0">
          {brands.map((b) => (
            <BrandTile key={b.name} brand={b} />
          ))}
        </Marquee>
      </footer>
    </div>
  );
}

function BrandTile({ brand }: { brand: Brand }) {
  return (
    <div className="flex items-center justify-center h-16 sm:h-24 min-w-[140px] sm:min-w-[200px] px-5 sm:px-8 shrink-0">
      <img
        src={brand.src}
        alt={brand.name}
        className="h-full w-auto object-contain"
      />
    </div>
  );
}

export default App;
